import React from 'react';
import { observer } from 'mobx-react';
import { Button, Icon } from 'semantic-ui-react';
import { action, toJS } from 'mobx';

import Modal from '../../../shared/Modal/';
import store from '../store';
import DragDropFile from '../../Shared/DragDropComponent';
import moment from 'moment';
import { ReplaceFileNameUpload } from '@utils/functions';
import { renderDate } from '../../Shared';

@observer
class UploadComponent extends React.Component {
  handleRemoveFile = id => {
    store.handleRemoveFile(id);
  };

  @action handleUpload = (fileList = [], reportType) => {
    store.supplementaryInfo = {
      ...toJS(store.supplementaryInfo),
    };

    const { functionCallback } = store.modalUploadParams;

    const attachments = store.supplementaryInfo?.Attachments ? toJS(store.supplementaryInfo.Attachments) : [];
    const dictationFiles = store.supplementaryInfo?.Attachments
      ? toJS(store.supplementaryInfo.Attachments).filter(i => i.Type === 5)
      : [];
    const attachment = fileList.map(i => ({
      FileName: i.name,
      Id: 0,
      NumberOfPages: i.numberOfPages,
      Type: reportType,
      Title:
        reportType === 5
          ? ReplaceFileNameUpload(
              'Supplementary',
              store.supplementaryInfo.SuppNo,
              store.claimantSelected?.FullName,
              store.specialistSelected?.Title,
              store.specialistSelected?.FullName,
              renderDate(store.supplementaryInfo.DateRequest, false) || '',
              false,
              '',
              !!dictationFiles.length ? dictationFiles.length + 1 : 1,
            )
          : i.title,
      CreatedDate: moment(),
    }));
    const newAttachments = [...attachment, ...attachments].map((i, idx) => ({
      ...i,
      key: idx,
    }));
    store.supplementaryInfo = {
      ...toJS(store.supplementaryInfo),
      Attachments: newAttachments,
    };

    if (this.props.functionCallback) {
      store.toggleModalModalUpload(false);
      this.props.functionCallback();
    }
    if (functionCallback) {
      store.toggleModalModalUpload(false);
      functionCallback(fileList, reportType);
    }
  };

  render() {
    const { isOpenModalUpload, modalUploadParams } = store;
    const {
      reportType,
      attachments,
      option,
      multiple,
      disabled,
      disabledDelete,
      uploadTitle,
      disableDragDrop,
    } = modalUploadParams;
    const { Attachments } = store.supplementaryInfo;

    const attachments_ = Attachments.filter(({ Type }) => Type === reportType);

    const title =
      attachments_ && !!attachments_.length
        ? `${attachments_.length} ${attachments_.length > 1 ? 'attachments' : 'attachment'} ${
            attachments_.length > 1 ? 'are' : 'is'
          } found`
        : disabled
        ? 'No files found'
        : `Upload your attachment`;

    const rule = option || null;
    return (
      <Modal
        visible={isOpenModalUpload}
        width={600}
        onCancel={() => store.toggleModalModalUpload(false, {})}
        className="custom-modal"
        footer={
          <React.Fragment>
            <Button color="red" onClick={() => store.toggleModalModalUpload(false, {})}>
              <Icon name="close" /> Close
            </Button>
          </React.Fragment>
        }
        title={title}
      >
        <DragDropFile
          onUploadFile={this.handleUpload}
          onDeleteFile={this.handleRemoveFile}
          type={reportType}
          accept={rule ? rule.allowedExtensions : null}
          maxSize={rule ? parseInt(rule.maxFileSize.replace('MB')) : 50}
          multiple={multiple}
          attachments={attachments}
          disabled={disabled}
          disabledDelete={disabledDelete}
          uploadTitle={uploadTitle}
          disableDragDrop={disableDragDrop}
          renderAttachment={store.renderAttachment}
          toggleModalConfirm={store.toggleModalConfirm}
          toggleModalModalUpload={store.toggleModalModalUpload}
          Attachments={store.supplementaryInfo?.Attachments}
        />
      </Modal>
    );
  }
}
export default UploadComponent;
